import React from "react";

const LottieLoader: React.FC = () => {
  return (
    <div
      style={{
        width: 320,
        height: 320,
        margin: "0 auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        src="/app/calculating-eeat.gif"
        alt="Loading..."
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
          width: "auto",
          height: "auto",
        }}
      />
    </div>
  );
};

export default LottieLoader;
